import { Link } from "react-router-dom";
import { MessageCircle, MapPin, ExternalLink } from "lucide-react";
import { useLanguage, waLink } from "@/i18n";
import { LogoMark } from "./Navbar";

export default function Footer() {
  const { t } = useLanguage();
  const year = new Date().getFullYear();
  const links = [
    { id: "keunggulan", key: "advantages" },
    { id: "katalog", key: "catalog" },
    { id: "kalkulator", key: "calculator" },
    { id: "kata-kunci", key: "keywords" },
    { id: "lokasi", key: "location" },
  ];
  return (
    <footer className="bg-[#070E1A] text-slate-300 blueprint-grid-dark" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid md:grid-cols-3 gap-12">
        <div>
          <div className="flex items-center gap-3">
            <LogoMark className="w-11 h-11" />
            <div>
              <p className="font-display font-bold text-white text-lg tracking-tight">CV. Sinar Al Mubarokah</p>
              <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-sky-400">sinaralmubarokah.com</p>
            </div>
          </div>
          <p className="mt-5 text-sm leading-relaxed text-slate-400 max-w-sm">{t.footer.tagline}</p>
        </div>
        <div>
          <p className="font-mono text-xs tracking-[0.25em] uppercase text-sky-400 font-semibold">{t.footer.quick}</p>
          <ul className="mt-5 space-y-2.5">
            {links.map((l) => (
              <li key={l.id}>
                <a href={`/#${l.id}`} className="text-sm text-slate-400 hover:text-sky-300 transition-colors" data-testid={`footer-link-${l.id}`}>
                  {t.nav[l.key]}
                </a>
              </li>
            ))}
            <li>
              <Link to="/artikel" className="text-sm text-slate-400 hover:text-sky-300 transition-colors" data-testid="footer-link-artikel">
                {t.nav.blog}
              </Link>
            </li>
          </ul>
        </div>
        <div>
          <p className="font-mono text-xs tracking-[0.25em] uppercase text-sky-400 font-semibold">{t.footer.contact}</p>
          <div className="mt-5 space-y-3 text-sm">
            <a href={waLink(t.hero.waMsg)} target="_blank" rel="noopener noreferrer" data-testid="footer-wa-link"
              className="flex items-center gap-2.5 text-slate-300 hover:text-sky-300 transition-colors font-semibold">
              <MessageCircle size={16} className="text-sky-400" /> 0822-8280-0020
            </a>
            <p className="flex items-start gap-2.5 text-slate-400">
              <MapPin size={16} className="text-sky-400 shrink-0 mt-0.5" /> {t.location.address}
            </p>
            <a href="https://share.google/CVt7BF9is5ojq3Rlg" target="_blank" rel="noopener noreferrer" data-testid="footer-maps-link"
              className="inline-flex items-center gap-2 text-sky-300 hover:text-sky-200 font-semibold transition-colors">
              Google Maps <ExternalLink size={14} />
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row justify-between gap-2 text-xs text-slate-500">
          <p>© {year} CV. Sinar Al Mubarokah. {t.footer.rights}</p>
          <p className="font-mono tracking-wider">PABRIK KAYU JAKARTA · STOK MELIMPAH · HARGA PABRIK</p>
        </div>
      </div>
    </footer>
  );
}
